<div id="wrapper-menu">
  <div class="container-fluid">
    <nav class="navbar header-top">
      <a class="navbar-brand" [routerLink]="isNSI ? null : ['/']" [attr.tabindex]="isNSI ? -1 : null" [attr.aria-disabled]="isNSI ? true : null" [style.pointer-events]="isNSI ? 'none' : 'auto'" [style.cursor]="isNSI ? 'default' : 'pointer'">
        <i class="icon-CGA"></i>
        <h1>
          <span>CGA </span>
          <span class="logo-bold"> DIRECTA</span>
        </h1>
      </a>

      <ul class="proj-info-header">
        <li>
          <span data-testid="displayName">{{securityService.userDetails.displayName}}</span>
          <span class="proj-number" *ngIf="securityService.userDetails.utente">CGA nº {{getUtenteTrimed()}}</span>
        </li>
        <li class="proj-icon-user nav-item dropdown d-sm-none d-md-block">
          <span aria-label="Menu com links" data-bs-toggle="dropdown" class="icon-user"></span>
        </li>
        <li>
          <ul class="proj-info-header">
            <li *ngIf="isHelpVisible()" class="proj-help">
              <a href="" aria-label="Ajuda" (click)="getHelpFile()" tooltip="Ajuda desta página">
                <span class="icon-help"></span>Ajuda
              </a>
            </li>
            <li class="proj-close">
              <a href="./signout" aria-label="Sair" (click)="limparFiltro()">
                <span class="icon-off"></span>Sair
              </a>
              <span class="debugInfo">Versão {{getVersion()}}</span>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</div>

<!-- FORM FAKE -->
<form *ngIf="(!isExSub && getCurrentStep() !== undefined) || isExSub" id="formGetHelpFile" #cgaGetHelpFileForm="ngForm" name="formGetHelpFile" method="POST" target="_blank" referrerpolicy="origin">
  <!--<input type="hidden" name="h_queryParams" id="h_queryParams" value="{{workflowTemplate.workFlowHelpLink}}">-->
  <input #cgaGetHelpFileFormInput type="hidden" name="h_queryParams" id="h_queryParams" value="">
  <input type="hidden" name="h_transfDir" id="h_transfDir" value="Download">
  <input type="hidden" name="h_operId" id="h_operId" value="PubFich">
</form>
